import classNames from 'classnames';
import React from 'react';
import styles from './index.module.scss';

export const Tfoot: React.FC<React.HTMLAttributes<HTMLTableSectionElement>> = props => {
  const { children, className, ...rest } = props;
  const containerClass = classNames(styles.tbody, className);

  return (
    <tfoot {...rest} className={containerClass}>
      {children}
    </tfoot>
  );
};
